export * from './TextWithImage'
